export default __webpack_public_path__ + "static/Takibi Tent Chair Illustration-05da11177712da8ef9a88e30e186cbd1.png";